import React from 'react';

const SelectBox = ({ value, onChange, options, keyValue, disabled }) => {
  
  return (
    <select
      className='waver-select-box w-100 border-radius-0'
      value={value}
      onChange={(e) => onChange(keyValue, e.target.value)}
      disabled={disabled}
    >
      <option value="">{'선택하세요'}</option>
      {
        options && options.length > 0 && options.map((opt, idx) => (
          <option key={keyValue+'_'+idx} value={opt.id}>
            {opt.name}
          </option>
        ))
      }
    </select>
  );
};

export default SelectBox;